import ErrorModal from "components/Modal/ErrorModal";
import * as PropTypes from "prop-types";
import React from "react";
import { getErrorMessage, refreshPage } from "utils";

const ErrorFallbackModal = ({ error }) => (
  <ErrorModal errorMessage={getErrorMessage(error)} handleOk={refreshPage} />
);

export default ErrorFallbackModal;

ErrorFallbackModal.propTypes = {
  error: PropTypes.instanceOf(Error).isRequired,
};
